import React from 'react';
import { Clock } from 'lucide-react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';

export const formatMonth = (ym, lang) => {
  if (!ym) return '';
  const [y, m] = ym.split('-');
  const d = new Date(Number(y), Number(m) - 1, 1);
  return d.toLocaleDateString(lang === 'ar' ? 'ar-AE' : 'en-US', { year: 'numeric', month: 'long' });
};

export const MonthSwitcher = ({ lang, months, statements = [], value, onChange, testId = 'month-switcher' }) => (
  <div className="flex items-center gap-3 flex-wrap">
    <div className="text-xs text-[#111827]/60 dark:text-slate-400 flex items-center gap-1"><Clock className="w-3.5 h-3.5" /> {lang === 'ar' ? 'الشهر:' : 'Month:'}</div>
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className="w-full sm:w-60 h-9 bg-white dark:bg-slate-800 border-[#e5e7eb] dark:border-slate-700" data-testid={testId}><SelectValue /></SelectTrigger>
      <SelectContent>
        {months.map((m) => {
          const st = statements.find((s) => s.month === m);
          return (
            <SelectItem key={m} value={m} data-testid={`${testId}-opt-${m}`}>
              {formatMonth(m, lang)} {st ? `· ${st.txn_count || 0} ${lang === 'ar' ? 'عملية' : 'txns'}` : ''}
            </SelectItem>
          );
        })}
      </SelectContent>
    </Select>
  </div>
);
